import React from 'react';
import { string } from 'prop-types';
import { useSpring, animated } from 'react-spring';
import Logo from 'assets/images/logo-axelent.svg';

import clsx from 'clsx';
import styles from './Footer.module.scss';

const Footer = ({ phoneNumber, email, address }) => {
  const props = useSpring({ to: { opacity: 1 }, from: { opacity: 0 } });

  return (
    <animated.div style={props}>
      <div className={styles.footerWrapper}>
        <div className={styles.logoContainer}>
          <Logo style={{ height: '54px' }} />
        </div>
        <div className={styles.textContent}>
          <ul className={styles.linkList}>
            <li className={styles.listItem}>
              <span className={styles.footerText}>{address}</span>
            </li>
            <li className={styles.listItem}>
              <span className={clsx(styles.footerText, styles.footerOpacity)}>
                Telefon
              </span>
              <span className={styles.footerText}>{phoneNumber}</span>
            </li>
            <li className={styles.listItem}>
              <span className={clsx(styles.footerText, styles.footerOpacity)}>
                Epost
              </span>
              <span className={styles.footerText}>{email}</span>
            </li>
          </ul>
          <div className={styles.copy}>
            <span className={clsx(styles.footerText, styles.footerOpacity)}>
              &copy; Axelent AB. All rights reserved.
            </span>
          </div>
        </div>
      </div>
    </animated.div>
  );
};

Footer.propTypes = {
  phoneNumber: string,
  email: string,
  address: string,
};

Footer.defaultProps = {
  phoneNumber: '',
  email: '',
  address: '',
};

export default Footer;
